import { defineComponent as _defineComponent } from 'vue';
import { VContainer, VRow, VCol } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosIconButtonDemo',
    setup(__props) {
        return { __sfc: true, VContainer, VRow, VCol, CodePreview, DemoSection };
    }
});
